export function initReviews() {
    document.querySelectorAll('[data-reviews-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('.module-reviews__track');
        const dots = carousel.querySelectorAll('.module-reviews__dot');
        const prev = carousel.querySelector('.module-reviews__prev');
        const next = carousel.querySelector('.module-reviews__next');
        const count = parseInt(carousel.dataset.count) || 1;
        let current = 0;
        let timer = null;
        const AUTOPLAY_MS = 2000;

        function goTo(i) {
            current = ((i % count) + count) % count;
            track.style.transform = `translateX(${-current * 100}%)`;
            dots.forEach((d, di) => d.classList.toggle('is-active', di === current));
        }

        const startAuto = () => {
            if (count <= 1) return;
            stopAuto();
            timer = setInterval(() => goTo(current + 1), AUTOPLAY_MS);
        };
        const stopAuto = () => {
            if (timer) { clearInterval(timer); timer = null; }
        };

        prev?.addEventListener('click', () => { goTo(current - 1); stopAuto(); startAuto(); });
        next?.addEventListener('click', () => { goTo(current + 1); stopAuto(); startAuto(); });
        dots.forEach((d, di) => d.addEventListener('click', () => { goTo(di); stopAuto(); startAuto(); }));

        carousel.addEventListener('mouseenter', stopAuto);
        carousel.addEventListener('mouseleave', startAuto);

        // Swipe support
        let startX = 0;
        let isDown = false;

        track.addEventListener('pointerdown', (e) => {
            isDown = true;
            startX = e.clientX;
        });
        track.addEventListener('pointerup', (e) => {
            if (!isDown) return;
            isDown = false;
            const dx = e.clientX - startX;
            if (Math.abs(dx) > 50) {
                dx < 0 ? goTo(current + 1) : goTo(current - 1);
                stopAuto(); startAuto();
            }
        });
        track.addEventListener('pointercancel', () => { isDown = false; });

        // IntersectionObserver for autoplay
        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => e.isIntersecting ? startAuto() : stopAuto());
        });
        io.observe(carousel);
    });
}
